import { DefaultTheme } from 'styled-components';

export const defaultTheme: DefaultTheme = {
	fonts: {
		stack: 'OatmealPro-Regular',
		medium: 'OatmealPro-Medium',
	},
	colors: {
		principal: {
			alamak: '#72DBAA',
			orion: '#140F33',
			vanth: '#646174',
			moon: '#B7B7B7',
			ceres: '#E6E6E6',
			eris: '#F2F2F2',
			sirius: '#FCFCFC',
			abell: '#0F0F0F',
			wasp: '#F0EFFE',
			air: '#F8F8F8',
			pure: '#FFFFFF',
			'light-alamak': '#E3F8EE',
			'light-sword': '#fff2f2',
		},
		secondary: {
			wasp_100: '#F6F5FF',
		},
		extra: {
			earth: '#426DD8',
			crab: '#857BF9',
			volans: '#FF97D5',
			sword: '#FF7576',
			omega: '#FFBE5C',
			cygnus: '#121F3D',
			corvus: '#262255',
			canes: '#5C2A48',
			antares: '#4D2323',
			mars: '#716661',
			secMars800: '#482524',
			success: '#17B12A',
			success_100: '#E3F8EE',
			success_500: '#1B9D06',
			sirius: '#FCFCFC',
			saturn: '#684103',
			saturn_100: '#FEF8ED',
			saturn_500: '#F2A93D',
			beam_800: '#130F31',
			space_600: '#B8B8BB',
			space_700: '#636172',
			error_100: '#FFE8E8',
			error_500: '#FF433E',
		},
	},
	breakpoints: {
		xs: '320px',
		sm: '576px',
		md: '767px',
		lg: '991px',
		xl: '1199px',
		xxl: '1399px',
		xg: '1499px',
	},
};
